<template>
  <Modal
    modalType="StrokeWidth"
    mayCancel="true"
    v-on:cancel="onDone"
    anchorStyle="topAuto"
  >
    <div class="BrushCollection">
      <div
        v-bind:class="getSWClass(sw)"
        v-for="sw in strokeWidths"
        v-bind:key="sw"
        v-on:click="setStrokeWidth(sw)"
      >
        <div
          class="StrokeWidthIndicator_Circle"
          v-bind:style="getStrokeWidthCircleStyle(sw)"
        ></div>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Component } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import ToolType from "@/wbcontroller/types/ToolType";
import WBComponent from "@/WBComponent";
import { ModalMutations } from "@/store/modules/modal";
import { GlobalMutations } from "@/store/mutations";

@Component({ components: { Modal } })
export default class StrokeWidthPickerModal extends WBComponent {
  get isForEraser(): boolean {
    return this.state.hud.tool === ToolType.Eraser;
  }

  get activeStrokeWidth(): number {
    if (this.isForEraser) {
      return this.state.hud.strokeWidthForEraser;
    } else {
      return this.state.hud.strokeWidth;
    }
  }

  get strokeWidths(): number[] {
    return this.state.toolConfig.strokeWidths;
  }

  getSWClass(sw: number): string {
    return sw === this.activeStrokeWidth
      ? "StrokeWidthIndicator m-active"
      : "StrokeWidthIndicator";
  }

  getStrokeWidthCircleStyle(n: number): string {
    return `
      width: ${n}px;
      height: ${n}px;
      border-radius: ${n}px;`;
  }

  setStrokeWidth(strokeWidth: number) {
    if (this.isForEraser) {
      GlobalMutations.setStrokeWidthForEraser(this.$store.commit, strokeWidth);
    } else {
      GlobalMutations.setStrokeWidth(this.$store.commit, strokeWidth);
    }
    this.onDone();
  }

  onDone() {
    ModalMutations.closeModals(this.$store.commit);
    this.$emit("done");
  }
}
</script>

<style scoped lang="scss">
.BrushCollection {
  display: flex;
  flex-wrap: wrap;
}

.StrokeWidthIndicator {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.24);
  margin-right: 5px;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border: 2px solid #ff8a65;
  }

  &.m-active {
    border: 4px solid #ff8a65;
  }
}

.StrokeWidthIndicator_Circle {
  background-color: black;
}
</style>
